import { useContext, useEffect, useState, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import PageLoader from '../PageLoader';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Faq = () => {
    const { t } = useTranslation();
    const { handleCallApi, } = useContext(MyContext);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [faqList, setFaqList] = useState([]);
    const [showFaqs, setShowFaqs] = useState([]);

    const FaqRef = useRef(false);

    useEffect(() => {
        handleGetFaqList();
    }, []);

    const handleGetFaqList = async () => {
        if (FaqRef.current) return;
        FaqRef.current = true;
        const Response = await handleCallApi("Get", "customer/faq_data");
        if (Response && Response.data && Response.data.faq_list) {
            setFaqList(Response.data.faq_list);
        }
        setLoading(false);
    }

    const handleShowFaq = (id) => {
        if (showFaqs.includes(id)) {
            const FilterFaq = showFaqs.filter((item) => item !== id);
            setShowFaqs(FilterFaq);
        } else {
            setShowFaqs((prev) => [...prev, id]);
        }
    }

    return (
        <div className="py-3">

            {!loading && <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">{t("Faq Question & Answer")}</h1>

                {faqList.length === 0 ? (
                    <div className="text-center py-12 px-4 bg-white rounded-2xl shadow border border-gray-150 flex flex-col items-center">
                        <div className="w-16 h-16 bg-blue-50 text-[--bg-color] rounded-full flex items-center justify-center mb-4">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 18H11V16H13V18ZM13 14H11V8H13V14Z" fill="currentColor"/>
                            </svg>
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t("No FAQs Available")}</h2>
                        <p className="text-gray-500 mb-6 max-w-sm">{t("Have questions? Contact our customer support directly.")}</p>
                        <button onClick={() => navigate("/")} className="bg-[--bg-color] text-white px-6 py-2.5 rounded-xl font-semibold hover:opacity-90 active:scale-95 duration-150 shadow-md">
                            {t("Go Home")}
                        </button>
                    </div>
                ) : (
                    <div className="space-y-3">
                        {faqList.map((item, index) => {
                            const isshow = showFaqs.includes(item.id);
                            return <div key={index} className="bg-gray-100 px-[20px] shadow rounded-[15px]">
                                <div onClick={() => handleShowFaq(item.id)} className="flex items-center justify-between py-[15px] cursor-pointer">
                                    <h1 className='font-medium'>{item.title}</h1>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 15C11.744 15 11.488 14.9021 11.293 14.7071L7.29301 10.7071C6.90201 10.3161 6.90201 9.68401 7.29301 9.29301C7.68401 8.90201 8.31607 8.90201 8.70707 9.29301L12 12.586L15.293 9.29301C15.684 8.90201 16.3161 8.90201 16.7071 9.29301C17.0981 9.68401 17.0981 10.3161 16.7071 10.7071L12.7071 14.7071C12.5121 14.9021 12.256 15 12 15Z" fill="currentColor" />
                                    </svg>
                                </div>

                                <AnimatePresence initial={false}>
                                    {isshow && <motion.div
                                        key="content"
                                        initial="collapsed"
                                        animate="open"
                                        exit="collapsed"
                                        variants={{
                                            open: { height: "auto", opacity: 1 },
                                            collapsed: { height: 0, opacity: 0 },
                                        }}
                                        transition={{ duration: 0.3 }}
                                        className='overflow-hidden'
                                    >
                                        <p className='text-gray-600 leading-5 pb-[15px]'>{item.description}</p>
                                    </motion.div>}
                                </AnimatePresence>
                            </div>
                        })}
                    </div>
                )}

            </div>}

            <PageLoader loading={loading} />

        </div>
    )
}

export default Faq